import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Star, Utensils } from "lucide-react";

export function ChefCard({ chef, compact = false }) {
  const c = chef;
  return (
    <Link to={`/chefs/${c.slug}`} data-testid={`chef-card-${c.slug}`}
      className="group block rounded-3xl bg-white border border-border shadow-soft hover:shadow-lift hover:-translate-y-1 transition-all duration-300 overflow-hidden">
      <div className={`relative ${compact ? "aspect-square" : "aspect-[4/3.6]"} overflow-hidden bg-secondary`}>
        {c.avatar ? (
          <img src={c.avatar} alt={c.display_name} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        ) : (
          <div className="w-full h-full grid place-items-center font-heading text-5xl font-black text-coral/60">{c.display_name?.[0]}</div>
        )}
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-ink/70 to-transparent" />
        <div className="absolute left-3 right-3 bottom-3 text-white">
          <h3 className="font-heading text-lg font-black leading-tight line-clamp-1 drop-shadow">{c.display_name}</h3>
          {c.city && <p className="mt-0.5 inline-flex items-center gap-1 text-xs font-bold text-white/90"><MapPin size={12} /> {c.city}</p>}
        </div>
      </div>
      <div className="p-4">
        {c.specialties?.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mb-3">
            {c.specialties.slice(0, 3).map((s) => (
              <span key={s} className="rounded-full bg-secondary px-2.5 py-0.5 text-[11px] font-bold text-ink-soft">{s}</span>
            ))}
          </div>
        )}
        <div className="flex items-center justify-between text-sm">
          <span className="inline-flex items-center gap-1.5 font-bold text-ink-soft"><Utensils size={14} className="text-coral" /> {c.recipe_count} {c.recipe_count === 1 ? "recipe" : "recipes"}</span>
          <span className="inline-flex items-center gap-1 font-bold text-amber-700"><Star size={14} className="fill-gold text-gold" /> {c.rating_avg || "New"}</span>
        </div>
      </div>
    </Link>
  );
}
